import { ICreditAttachDocument } from "@/core/repositories/credit";
import { CreditUploadDocument } from "./atom/documentUpload";

interface CreditUploadFormDocument {
  processId: number;
  documentType: { value: string } | null;
}

const isDefined = <T>(value: T | null): value is T => value !== null;

export const isAttachableCreditDocument = (document: CreditUploadDocument): boolean => {
  return Boolean(!document.error && document.isUploaded && document.response?.data.document?.fileName);
};

export const getAttachableCreditDocuments = (documents: CreditUploadDocument[]): CreditUploadDocument[] => {
  return documents.filter(isAttachableCreditDocument);
};

export const buildCreditAttachFiles = (
  documents: CreditUploadDocument[],
  formDocuments: CreditUploadFormDocument[]
): ICreditAttachDocument[] => {
  return getAttachableCreditDocuments(documents)
    .map(document => {
      const formDocument = formDocuments.find(eachFormDocument => eachFormDocument.processId === document.processId);
      const documentTypeId = Number.parseInt(formDocument?.documentType?.value ?? "");
      const responseDocument = document.response?.data.document;

      if (!documentTypeId || !responseDocument) {
        return null;
      }

      return {
        documentTypeId,
        fileName: responseDocument.fileName,
        fileDisplayName: responseDocument.displayName,
        mimeType: responseDocument.mimeType,
        size: responseDocument.size,
      };
    })
    .filter(isDefined);
};
